export default "__VITE_ASSET__Dc$z$E5D__"